/**
 * Appends a returnTo parameter to a login URL so the user is redirected
 * back to the correct page after SSO completes.
 */
export function appendReturnTo(loginUrl: string, returnTo: string): string {
    if (!returnTo || returnTo === "/") {
        return loginUrl;
    }
    const separator = loginUrl.includes("?") ? "&" : "?";
    return `${loginUrl}${separator}returnTo=${encodeURIComponent(returnTo)}`;
}
